<template>
  <div>
    <div class="search flex">
      <span class="tit">发送邮件列表</span>
      <div>
        <el-button @click="toEditEmail(0)" size="mini" class="addBtn">新增邮件</el-button>
      </div>
    </div>
    <div class="instrument mt-5">
      <el-table :data="page.list" class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 292px)"
                style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
                max-height="calc(100vh - 292px)">
        <el-table-column label="邮件主题" prop="subject" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" align="center" width="90">
          <span slot-scope="scope" :state="scope.row.emailStatus">{{ scope.row.emailStatus|stateFmt }}</span>
        </el-table-column>
        <el-table-column label="发送时间" prop="sendDate" align="center" width="176"></el-table-column>
        <el-table-column label="发送数量" prop="sendCount" align="center" width="80"></el-table-column>
        <el-table-column label="完成时间" prop="completeDate" align="center" width="176"></el-table-column>
        <el-table-column label="备注" prop="remark" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button class="btn op-btn" @click="toEditEmail(scope.row.id)" type="text" size="small">详情</el-button>
            <el-button class="btn op-btn" v-if="scope.row.emailStatus == 1" @click="stopSend(scope.row)" type="text"
                       size="small">终止发送
            </el-button>
            <el-button class="btn op-btn" v-if="scope.row.emailStatus == 0" @click="delEmail(scope.row.id)" type="text"
                       size="small">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
        class="pagination"
        :hide-on-single-page="true"
        background
        prev-text="Prev"
        next-text="Next"
        @current-change="skipPage"
        :current-page="page.current"
        :page-size="page.size"
        layout="prev, pager, next"
        :total="page.total">
    </el-pagination>


  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "emailList",
  data() {
    return {
      page: {
        current: 1,
        size: 10,
        total: 12,
        list: []
      }
    }
  },
  mounted() {
    this.getData();
  },
  filters: {
    stateFmt(state) {
      state = Number(state);
      switch (state) {
        case 0:
          return '草稿';
        case 1:
          return '发送中';
        case 2:
          return '发送完成';
        case 3:
          return '发送终止';
        default:
          return '-';
      }
    }
  },
  methods: {
    toEditEmail(id) {
      if (!id) {
        this.$router.push('/admin/sendEmail/edit');
      } else {
        this.$router.push({path: '/admin/sendEmail/edit', query: {id: id}});
      }
    },
    stopSend(item) {
      if (!item || !item.id) {
        return;
      }
      this.$messageBox.confirm('确定要停止此发送任务吗?', '停止确认提示', {type: 'warning'}).then(() => {
        this.$ajax.post(base.basePath + 'communication/comm-email/admin/stop/' + item.id).then(res => {
          if (res.data.status === 'success') {
            this.$message.success('停止成功');
            item.emailStatus = 3;
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('操作失败');
        });
      })
    },
    skipPage(curPage) {
      this.page.current = curPage;
      this.getData();
    },
    delEmail(id) {
      if (!id) {
        return;
      }
      let that = this;
      that.$messageBox.confirm('确定要删除吗?', '删除提示', {type: 'warning'}).then(() => {
        that.$ajax.post(base.basePath + 'communication/comm-email/admin/del/' + id).then(res => {
          if (res.data.status === 'success') {
            let delIndex = -1;
            that.page.list.forEach((o, i) => {
              if (id == o.id) {
                delIndex = i;
              }
            });
            that.page.list.splice(delIndex, 1);
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          that.$message.error('操作失败');
        })
      })
    },
    getData() {
      let that = this;
      that.$ajax.get(base.basePath + 'communication/comm-email/admin/list/page', {
        params: {
          page: that.page.current,
          size: that.page.size
        }
      }).then(res => {
        if (res.data.status === 'success') {
          that.page.current = res.data.current;
          that.page.size = res.data.size;
          that.page.total = res.data.total;
          that.page.list = res.data.rows;
        } else {
          that.$message.error('数据加载失败');
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('数据加载失败');
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/admin.scss';

span[state] {
  display: inline-block;
  width: 80px;
  height: 28px;
  line-height: 28px;
  text-align: center
}

span[state='0'] {
  color: #606266;
  background-color: #DCDFE6
}

span[state='1'] {
  color: #E6A23C;
  background-color: #FAECD8
}

span[state='2'] {
  color: #67C23A;
  background-color: #E1F3D8
}

span[state='3'] {
  color: #F56C6C;
  background-color: #FDE2E2
}

button.op-btn {
  padding: 0
}
</style>